import type { DataSet, NumericPoint } from "@incytestudios/ddv";
import { getPumpTorqueFtLbs } from "@/libs/calculations/pumps/pumpData";
import { isFinitePoint, isNaturalPoint } from "../_common";
import type { PumpSpeedTorqueChartContext } from "./d";

const INITIAL_RPM = 3800;
const RPM_DECAY_RATIO = 0.01;
const MIN_RPM = 0.1;
const MAX_ITERATIONS = 150;

export const getTorqueDataPoints = (
  context: PumpSpeedTorqueChartContext
): DataSet => {
  const { requiredPumpBrakeHP, operatingRPM } = context;

  const points: NumericPoint[] = [];
  let currentRPM = INITIAL_RPM;
  let previousRPM = operatingRPM;
  let previousHP = requiredPumpBrakeHP;
  let rpmTwoStepsAgo = operatingRPM;
  let iterations = 0;

  while (currentRPM > MIN_RPM && iterations < MAX_ITERATIONS) {
    const currentHP =
      iterations === 0
        ? requiredPumpBrakeHP * Math.pow(currentRPM / operatingRPM, 3)
        : previousHP * Math.pow(currentRPM / previousRPM, 3);
    const torqueFtLbs = getPumpTorqueFtLbs(currentRPM, currentHP);

    if (torqueFtLbs < 0) {
      break;
    }

    points.push({ x: currentRPM, y: torqueFtLbs });

    const nextRPM = currentRPM - rpmTwoStepsAgo * RPM_DECAY_RATIO;
    rpmTwoStepsAgo = currentRPM;
    previousRPM = currentRPM;
    previousHP = currentHP;
    currentRPM = nextRPM;
    iterations += 1;
  }

  return {
    title: "Pump Speed Torque",
    xAxisLabel: "Speed (rpm)",
    yAxisLabel: "Torque (ft-lbs)",
    points: points.filter(isFinitePoint).filter(isNaturalPoint)
  };
};
